export default __webpack_public_path__ + "static/media/brand_12.68c15c38.png";